import __var_0__ from '@stdlib/math/base/assert/is-nan';
import __var_1__ from '@stdlib/math/base/special/expm1';
import __var_2__ from '@stdlib/math/base/special/exp';
import __var_3__ from '@stdlib/math/base/special/log1p';
import __var_4__ from '@stdlib/math/base/special/ln';
import __var_5__ from '@stdlib/math/base/special/abs';
import __var_6__ from '@stdlib/constants/math/float64-ln-two';
import __var_7__ from '@stdlib/constants/math/float64-ninf';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isnan = __var_0__;
var expm1 = __var_1__;
var exp = __var_2__;
var log1p = __var_3__;
var ln = __var_4__;
var abs = __var_5__;
var LN2 = __var_6__;
var NINF = __var_7__;


// MAIN //

/**
* Computes the natural logarithm of \\( 1-\exp(-|x|) \\).
*
* @param {number} x - input value
* @returns {number} function value
*
* @example
* var v = log1mexp( 1.1 );
* // returns ~-0.40477
*
* @example
* var v = log1mexp( 0.0 );
* // returns -Infinity
*
* @example
* var v = log1mexp( NaN );
* // returns NaN
*/
function log1mexp( x ) {
	var ax;
	if ( isnan( x ) ) {
		return NaN;
	}
	if ( x === 0.0 ) {
		return NINF;
	}
	ax = abs( x );
	if ( 0.0 < ax && ax <= LN2 ) {
		return ln( -expm1( -ax ) );
	}
	// Case: |x| > ln(2)
	return log1p( -exp( -ax ) );
}


// EXPORTS //
export default log1mexp;
